/**
 * Permite injectar css a un documento
 *
 * @param {string} css - la cadena de regla css
 * @param {string} name - OPCIONAL el nombre del elemento que vamos a insertar (permite no insertarlo varias veces el mismo)
 * @param {object} options - Las opciones
 *
 * @return {HTMLElement} el elemento añadido
 */

export function injectStyle(css, name, { insertBefore = false, overwrite = true } = {}) {
  if (typeof css !== 'string' || typeof name !== 'string' || typeof document === 'undefined') {
    throw new Error('injectStyle: parametros incorrectos');
  }

  const found = document.querySelector(`#${name}`);
  if (found) {
    if (overwrite) {
      found.innerHTML = css;
    }
    return found;
  }
  const style = createStyleElement(name, insertBefore);
  style.appendChild(document.createTextNode(css));
  return style;
}

function createStyleElement(name, insertBefore) {
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.id = name;
  insertBefore ? head.insertBefore(style, head.firstElementChild) : head.appendChild(style);
  return style;
}
